// extracted by mini-css-extract-plugin
module.exports = {"table":"CwTable-table","tableAlternateRow":"CwTable-tableAlternateRow","nested":"CwTable-nested"};